import React, { useContext, useState } from "react";
import { NavLink, useHistory } from "react-router-dom";
import { css } from "glamor";
import AuthService from "../services/AuthService";
import { AuthContext } from "../context/AuthContext";
import { ScreenSizeContext } from "../context/ScreenSizeContext";
import Logo from "../static/dr_logo.png";

import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import CloseIcon from "@material-ui/icons/Close";

const Navbar = () => {
  const { isAuthenticated, user, setIsAuthenticated, setUser } =
    useContext(AuthContext);
  const { onMobile } = useContext(ScreenSizeContext);
  let history = useHistory();
  const [menuOpen, setMenuOpen] = useState(false);

  const logoutHandler = () => {
    AuthService.logout().then((data) => {
      if (data.success) {
        setMenuOpen(false);
        setUser(data.user);
        setIsAuthenticated(false);
        history.push("/login");
      }
    });
  };

  const linkStyle = css({
    color: "white",
    marginRight: "20px",
    ":hover": {
      color: "red",
      textDecoration: "none",
    },
  });

  const returnNavbar = () => {
    if (!onMobile) {
      if (!isAuthenticated) {
        return unauthenticatedNavbar();
      } else {
        return authenticatedNavbar();
      }
    } else {
      if (!isAuthenticated) {
        return unauthenticatedDrawer();
      } else {
        return authenticatedDrawer();
      }
    }
  };

  const unauthenticatedNavbar = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          width: "15%",
          paddingTop: "20px",
          marginLeft: "20px",
        }}
      >
        <NavLink
          exact={true}
          {...linkStyle}
          activeStyle={{
            color: "red",
          }}
          to="/"
        >
          <Typography>Home</Typography>
        </NavLink>
        <NavLink
          to="/login"
          {...linkStyle}
          activeStyle={{
            color: "red",
          }}
        >
          <Typography>Login</Typography>
        </NavLink>
      </div>
    );
  };

  const authenticatedNavbar = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-end",
          width: "100%",
          marginLeft: "20px",
          paddingTop: "8px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
            width: user.role === "admin" ? "20%" : "12%",
          }}
        >
          {user.role === "admin" ||
          user.role === "admin/user" ||
          user.role === "user" ? (
            <NavLink
              exact={true}
              {...linkStyle}
              activeStyle={{
                color: "red",
              }}
              to="/"
            >
              <Typography>Consultants</Typography>
            </NavLink>
          ) : null}
          <NavLink
            {...linkStyle}
            activeStyle={{
              color: "red",
            }}
            to="/account"
          >
            <Typography>Account</Typography>
          </NavLink>
          {user.role === "admin" || user.role === "admin/user" ? (
            <NavLink
              {...linkStyle}
              activeStyle={{
                color: "red",
              }}
              to="/admin"
            >
              <Typography>Admin</Typography>
            </NavLink>
          ) : null}
        </div>
        <div style={{ display: "flex", alignItems: "flex-end" }}>
          <p
            style={{ margin: "0px", paddingRight: "20px" }}
          >{`${user.username} (${user.role})`}</p>
          <Button
            type="Button"
            color="secondary"
            variant="contained"
            onClick={logoutHandler}
          >
            Logout
          </Button>
        </div>
      </div>
    );
  };

  const unauthenticatedDrawer = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          width: "100%",
        }}
      >
        <IconButton
          variant="outlined"
          style={{ color: "white" }}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <MenuIcon />
        </IconButton>
        <SwipeableDrawer
          anchor="top"
          open={menuOpen}
          onClose={() => setMenuOpen(false)}
          onOpen={() => setMenuOpen(true)}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              padding: "30px 20px 15px 20px",
              backgroundColor: "#13222D",
            }}
          >
            <div>
              <NavLink
                exact={true}
                {...linkStyle}
                activeStyle={{
                  color: "red",
                }}
                to="/"
                onClick={() => setMenuOpen(false)}
              >
                <Typography>Home</Typography>
              </NavLink>
              <NavLink
                to="/login"
                {...linkStyle}
                activeStyle={{
                  color: "red",
                }}
                onClick={() => setMenuOpen(false)}
              >
                <Typography>Login</Typography>
              </NavLink>
              <NavLink
                {...linkStyle}
                activeStyle={{
                  color: "red",
                }}
                to="/register"
                onClick={() => setMenuOpen(false)}
              >
                <Typography>Register</Typography>
              </NavLink>
            </div>
            <div style={{ position: "absolute", right: "15px", top: "15px" }}>
              <CloseIcon
                style={{ color: "white", cursor: "pointer" }}
                onClick={() => setMenuOpen(!menuOpen)}
              />
            </div>
          </div>
        </SwipeableDrawer>
      </div>
    );
  };

  const authenticatedDrawer = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          width: "100%",
        }}
      >
        <IconButton
          variant="outlined"
          style={{ color: "white" }}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <MenuIcon />
        </IconButton>
        <SwipeableDrawer
          anchor="top"
          open={menuOpen}
          onClose={() => setMenuOpen(false)}
          onOpen={() => setMenuOpen(true)}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              padding: "30px 20px 15px 20px",
              backgroundColor: "#13222D",
            }}
          >
            <div>
              <NavLink
                exact={true}
                {...linkStyle}
                activeStyle={{
                  color: "red",
                }}
                to="/"
                onClick={() => setMenuOpen(false)}
              >
                <Typography>Consultants</Typography>
              </NavLink>
              <NavLink
                {...linkStyle}
                activeStyle={{
                  color: "red",
                }}
                to="/account"
                onClick={() => setMenuOpen(false)}
              >
                <Typography>Account</Typography>
              </NavLink>
              {user.role === "admin" || user.role === "admin/user" ? (
                <NavLink
                  {...linkStyle}
                  activeStyle={{
                    color: "red",
                  }}
                  to="/admin"
                  onClick={() => setMenuOpen(false)}
                >
                  <Typography>Admin</Typography>
                </NavLink>
              ) : null}
            </div>
            <div style={{ position: "absolute", right: "15px", top: "15px" }}>
              <CloseIcon
                style={{ color: "white", cursor: "pointer" }}
                onClick={() => setMenuOpen(!menuOpen)}
              />
            </div>
            <div style={{ display: "flex", alignItems: "flex-end" }}>
              <p
                style={{ margin: "0px", paddingRight: "20px", color: "white" }}
              >{`${user.username} (${user.role})`}</p>
              <Button
                type="Button"
                color="secondary"
                variant="contained"
                onClick={logoutHandler}
              >
                Logout
              </Button>
            </div>
          </div>
        </SwipeableDrawer>
      </div>
    );
  };

  return (
    <AppBar position="static">
      <Toolbar>
        <NavLink to="/">
          <img src={Logo} style={{ height: "70px" }} alt="logo" />
        </NavLink>
        {returnNavbar()}
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
